import { useState, useEffect, useCallback } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Is this part of current path?
 *
 * @param path - path to search for
 */
export const useIsPath = (
  path = '/archive',
  { exact = false, endsWith = false } = {}
) => {
  const { pathname, search } = useLocation();

  const checkIsPath = useCallback(() => {
    if (exact) return pathname === path;
    if (endsWith) return pathname.endsWith(path);
    if (path === 'projectId') {
      return (
        /^\d+$/.test(pathname.slice(-4)) && !pathname.includes('/projects')
      );
    }
    /*   
    if (path === 'cached-shares') {
      return search.includes(path);
    }
    if (path === 'shared-tender-attachments') {
      return search.includes('cached-shares') && search.includes('key');
    }
    if (path === 'my-tenders-attachments') {
      return search.includes('my-tenders') && search.includes('key');
    }

    if (path === 'my-tenders') {
      return search.includes('my-tenders');
    } */

    return pathname.includes(path);
  }, [exact, path, pathname, endsWith, search]);

  const [isPath, setIsPath] = useState(checkIsPath);

  useEffect(() => {
    setIsPath(checkIsPath);
  }, [pathname, path, checkIsPath]);

  return isPath;
};
